"use client";

import { useEffect, useState } from "react";
import { useGetMe } from "../fetcher";

export const useIsLogging = () => {
  const { data, isLoading, isValidating } = useGetMe();
  const [isLogging, setIsLogging] = useState<boolean | null>(null);

  useEffect(() => {
    if (!isLoading && !isValidating) {
      if (data?.nickName) {
        setIsLogging(true);
      } else {
        setIsLogging(false);
      }
    }
  }, [data, isLoading, isValidating]);

  return {
    isLogging,
  };
};